<template>
  <div class="sendInvitation">
    <div v-if="ifSave" class="booking-content-large">
      <div class="logo-box"><img :src="logo" alt="" ref="logo" /></div>
      <div class="visit-name">
        {{ user.companyId == 303 ? invitationInfo.interviewee : invitationInfo.intervieweeName }}{{ $t('（接待人）') }}
      </div>
      <img src="@/assets/images/sendInvitationLine.png" alt="" class="sendInvitationLine" />
      <div class="visit-purpose">
        {{ $t('邀 ')
        }}<span class="visit-text">{{ invitationInfo.visitorName }} </span>{{ $t(' 来访') }}
      </div>
      <div class="infoLine"></div>
      <div class="visit-title">{{ $t('来访时间') }}</div>
      <div class="visit-title-info">
        {{ formatVisitTimeDisplay }}
      </div>
      <div class="visit-title">{{ $t('来访地点') }}</div>
      <div class="visit-title-info">
        {{ invitationInfo.address || $t('暂无') }}
      </div>
      <div class="infoLine"></div>
      <div class="code-box" v-if="!ifCancel">
        <div class="visit-title">{{ $t('来访二维码') }}</div>
        <vue-qr :text="invitationInfo.invitationCode" :size="142" :margin="0" ref="qrCode" class="code"></vue-qr>
        <img src="@/assets/images/sendInvitationOR.svg" alt="" class="sendInvitationOR" />
        <div class="visit-title-code">{{ $t('来访预约码') }}</div>
        <div class="verification">{{ invitationInfo.invitationCode }}</div>
        <div class="visit-tips">
          {{ $t('来访请使用二维码或预约码进行验证签到') }}
        </div>
        <div class="visit-tips">{{ $t('预约信息仅来访当日有效') }}</div>
      </div>
      <div class="approvalImg" v-else>
        <img :src="statusImg" alt="" />
      </div>
    </div>

    <div v-else-if="ifDisabled" class="booking-content">
      <div class="img">
        <img src="@/assets/images/detailsCard-not-img.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import { isMobileType } from '@/utils/isMobileType.js'
import H5Cropper from 'vue-cropper-h5'
Vue.use(H5Cropper)
import { getVisitByShareId, getCompanyInfo, LanguagesRESTful } from '@/services/api'
import vueQr from 'vue-qr'
import Vue from 'vue'
import {
  Field,
  Button,
  Form,
  RadioGroup,
  Radio,
  DatetimePicker,
  Popup,
  Calendar,
  Toast,
  Icon,
  PullRefresh,
} from 'vant'
import i18n, { LocaleMgr } from 'i18n'

/* i18n-ignore */
const defaultLang = {
  'zh-CN': '简体中文',
  'en-US': 'English',
}

Vue.use(Icon)
Vue.use(Field)
Vue.use(Button)
Vue.use(Form)
Vue.use(Radio)
Vue.use(Toast)
Vue.use(RadioGroup)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(Calendar)
Vue.use(PullRefresh)

export default {
  name: 'visitorInvitation',
  components: {
    vueQr,
  },
  data() {
    return {
      ifSave: false,
      ifCancel: false,
      invitationInfo: null,
      logo: null,
      status: null,
      statusImg: '',
      ifDisabled: false,
      allLang: defaultLang,
      locale: LocaleMgr.highestPriorityFirstLocale,
      user: JSON.parse(localStorage.getItem('user')) || {},
    }
  },
  methods: {
    async getBooking(shareId) {
      try {
        let res
        if (this.$route.query.data) {
          res = JSON.parse(this.$route.query.data)
        } else {
          res = await getVisitByShareId({ shareId })
        }
        if (res.status == 'cancel') {
          this.status = this.$t('已取消')
          this.statusImg = this.localeLabel === defaultLang["zh-CN"] ? require('@/assets/images/cancelIcon.png') : require('@/assets/imagesUS/cancelIconUS.png')
          this.ifCancel = true
        }
        if (res.status == 'pend') {
          this.status = this.$t('审批中')
          this.statusImg = this.localeLabel === defaultLang["zh-CN"] ? require('@/assets/images/pendApprovalIcon.png') : require('@/assets/imagesUS/pendApprovalIconUS.png')
          this.ifCancel = true
        }
        if (res.status == 'refuse') {
          this.status = this.$t('审批拒绝')
          this.statusImg = this.localeLabel === defaultLang["zh-CN"] ? require('@/assets/images/refuseApprovalIcon.png') : require('@/assets/imagesUS/refuseApprovalIconUS.png')
          this.ifCancel = true
        }
        if (res.status == 'completed') {
          this.status = this.$t('已失效')
          this.statusImg = this.localeLabel === defaultLang["zh-CN"] ? require('@/assets/images/failureIcon.png') : require('@/assets/imagesUS/completedIconUS.png')
          this.ifCancel = true
        }
        this.invitationInfo = res
        this.ifSave = res && res.id
      } catch (err) {
        console.log(err)
        this.ifSave = false
      }
    },
    async getLogo(companyCode) {
      const res = await getCompanyInfo(companyCode)
      this.logo = res.logo
      setTimeout(() => {
        if (document.body.clientHeight > 650) {
          this.height = document.body.clientHeight
          if (isMobileType.iOS() && isMobileType.isSafari()) {
            this.height = document.body.clientHeight + 50
          }
        } else {
          this.height = document.body.clientHeight + 100
          setTimeout(() => {
            this.$refs.bookingBox.style.height = this.height + 'px'
          }, 0)
        }
        if (!this.$refs.logo) return
        this.$refs.logo.onload = () => {
          let height = this.$refs.logo.height
          let width = this.$refs.logo.width
          if (height >= width && height >= 78) this.$refs.logo.height = 78
          if (width > height && width >= 94) this.$refs.logo.width = 94
        }
      }, 0)
    },
    async fetchAllLang() {
      const langParams = {
        // 0 未发布， 1 已发布
        status: 1,
        companyId: this.user.companyId
      }
      const list = await LanguagesRESTful.list(langParams)

      this.allLang = {
        ...defaultLang,
        ...list?.reduce((acc, { code, name }) => ({ ...acc, [code]: name }), {}),
      }
    },
  },
  computed: {
    locales() { return Object.values(this.allLang) },
    localeLabel() {
      return this.allLang[this.locale]
    },
    // 格式化来访时间显示
    formatVisitTimeDisplay() {
      if (!this.invitationInfo?.visitTime) return ''

      const startTime = dayjs(this.invitationInfo.visitTime)
      const endTime = this.invitationInfo.finishTime
        ? dayjs(this.invitationInfo.finishTime)
        : (this.invitationInfo.visitEndTime ? dayjs(this.invitationInfo.visitEndTime) : null)

      if (!endTime) {
        return startTime.format('YYYY-MM-DD HH:mm')
      }

      // 判断是否跨天
      // const isSameDay = startTime.format('YYYY-MM-DD') === endTime.format('YYYY-MM-DD')

      // if (isSameDay) {
      //   // 同一天，显示格式：YYYY-MM-DD HH:mm-HH:mm
      //   return `${startTime.format('YYYY-MM-DD HH:mm')}-${endTime.format('HH:mm')}`
      // } else {
      //   // 跨天，显示格式：YYYY-MM-DD HH:mm - YYYY-MM-DD HH:mm
      //   return `${startTime.format('YYYY-MM-DD HH:mm')} - ${endTime.format('YYYY-MM-DD HH:mm')}`
      // }
      return `${startTime.format('YYYY-MM-DD HH:mm')} ～ ${endTime.format('YYYY-MM-DD HH:mm')}`
    },
  },
  created() {
    if (this.$route.query.ifDisabled) {
      this.ifDisabled = this.$route.query.ifDisabled
      return
    }
    this.getBooking(`${this.$route.query.shareId}:${this.$route.query.id}`)
    this.getLogo(this.$route.query.companyCode)
  },
  async beforeCreate() {
    const navigationEntries = performance.getEntriesByType('navigation')
    if (navigationEntries.length > 0) {
      const navigation = navigationEntries[0]
      if (navigation.type === 'reload') {
        console.log(this.$route.query.data)
        const data = JSON.parse(this.$route.query.data)
        if (!this.$route.query.ifDisabled) {
          if (data) {
            try {
              const res = await getVisitByShareId({ shareId: data.shareId })
              if (res.status == 'cancel') {
                this.status = this.$t('已取消')
                this.statusImg = this.localeLabel === defaultLang["zh-CN"] ? require('@/assets/images/cancelIcon.png') : require('@/assets/imagesUS/cancelIconUS.png')
                this.ifCancel = true
              }
              if (res.status == 'pend') {
                this.status = this.$t('审批中')
                this.statusImg = this.localeLabel === defaultLang["zh-CN"] ? require('@/assets/images/pendApprovalIcon.png') : require('@/assets/imagesUS/pendApprovalIconUS.png')
                this.ifCancel = true
              }
              if (res.status == 'refuse') {
                this.status = this.$t('审批拒绝')
                this.statusImg = this.localeLabel === defaultLang["zh-CN"] ? require('@/assets/images/refuseApprovalIcon.png') : require('@/assets/imagesUS/refuseApprovalIconUS.png')
                this.ifCancel = true
              }
              if (res.status == 'completed') {
                this.status = this.$t('已失效')
                this.statusImg = this.localeLabel === defaultLang["zh-CN"] ? require('@/assets/images/failureIcon.png') : require('@/assets/imagesUS/completedIconUS.png')
                this.ifCancel = true
              }
              this.invitationInfo = res
              this.ifSave = true
            } catch (err) {
              console.log(err)
              if (
                dayjs().valueOf() -
                dayjs(this.$route.query.shareDate).valueOf() >
                60 * 1000 * 60 * 24
              ) {
                this.ifDisabled = true
              }
            }
          }
        }
      }
    }
  },
  mounted() {
    this.fetchAllLang()
  }
}
</script>
<style lang="less" scoped>
.sendInvitation {
  width: 100%;
  min-height: 100vh;
  max-width: 100%;
  background-image: url('../../../assets/images/sendInvitationBG.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding-top: 11px;
  display: flex;
  justify-content: center;
  padding-bottom: 120px;
}

.navBar-wrap {
  width: 100%;
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;

  .navBar {
    background: #ffffff;
    line-height: 40px;
    text-align: center;
    font-size: 18px;

    .title {
      font-size: 17px;
      font-weight: 500;
    }
  }
}

.space {
  margin-top: 12px;
  font-size: 17px;
  color: #333333;
  height: 56px;
}

/deep/.van-field__label {
  display: flex;
  align-items: center;
}

/deep/.van-cell__value {
  display: flex;
  align-items: center;
}

.timeBox {
  height: 72px;
  background: #f7f7f7;
  padding: 5px 12px 0px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;

  .time-btn {
    height: 44px;
    background: #009bff;
  }
}

/deep/.date-border {
  color: #009bff;
}

/deep/ .van-nav-bar .van-icon {
  color: #000000;
}

.interviewee-content {
  padding-top: 92px;

  .searchList {
    font-size: 16px;
    color: #333333;
    padding: 0px 12px;
    background: #ffffff;
    overflow: auto;

    li {
      line-height: 48px;
      padding: 0px 4px;
      border-bottom: 1px solid #ededed;
      display: flex;
      align-items: center;

      span {
        margin-left: 15px;
        color: #999999;
      }
    }
  }
}

.interviewee {
  height: 100%;
  background: #f6f6f6;

  .select-navBar {
    background: #ffffff;
    line-height: 40px;
    text-align: center;
    border-bottom: 1px solid #ececec;
    font-size: 18px;
    position: relative;

    .arrow {
      height: 100%;
      padding: 3px 19px;
      position: absolute;
    }

    .title {
      font-size: 17px;
      font-weight: 500;
    }
  }

  /deep/.search {
    height: 40px;
    font-size: 14px;

    img {
      height: 16px;
      width: 16px;
    }

    .van-cell__value {
      display: block;
    }
  }
}

.cropper {
  width: 54px;
  height: 66px;
  line-height: 66px;
  /* 切记position: relative一定要有 */
  position: relative;
  overflow: hidden;
  text-align: center;

  .img {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
}

.no-effect {
  background: #f6f6f6;
  font-size: 25px;
  text-align: center;
  height: 600px;
  line-height: 600px;
}

.timeInterval {
  padding-left: 13px;
  padding-right: 13px;
}

.time-notice {
  display: flex;
  padding-left: 16px;
  margin-top: 6px;

  img {
    height: 16px;
    width: 16px;
  }

  span {
    padding-left: 4px;
    height: 16px;
    font-size: 12px;
    color: #999999;
    line-height: 16px;
  }
}

/deep/.timeList {
  position: relative;
  border-top: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
  height: 275px;
  padding-top: 5px;
  padding-left: 16px;
  overflow: auto;

  .timeListCard {
    min-height: 52px;
  }

  .van-checkbox__label {
    width: 330px;
  }

  .timeListRange {
    display: block;
    border-bottom: 1px solid #ebebeb;
    padding-left: 6px;
    font-size: 16px;
    min-height: 50px;
    color: #000000;
    word-break: break-word;
    word-wrap: break-word;
  }
}

.address {
  display: flex;
  align-items: center;

  span {
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .icon-more {
    margin-left: 5px;
    width: 16px;
    height: 16px;
  }
}

.sendInvitationLine {
  margin-bottom: 20px;
  width: 288px;
  height: 6px;
}

.infoLine {
  width: 272px;
  border-top: 1px dashed #e2e8f6;
  margin-top: 24px;
}

.visit-title {
  height: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #646b73;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  margin-top: 20px;
  margin-bottom: 4px;
}

.visit-title-code {
  height: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #646b73;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  margin-bottom: 4px;
}

.visit-title-info {
  width: 272px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #1e2329;
  line-height: 22px;
  font-style: normal;
  text-align: center !important;
  display: flex;
  max-height: 66px;
  flex-direction: column;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sendInvitationOR {
  margin-top: 15px;
  margin-bottom: 8px;
  width: 203px;
  height: 17px;
}

.visit-tips {
  height: 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #707a8a;
  line-height: 20px;
  text-align: center;
  font-style: normal;
}

.booking-content-large {
  background-color: #ffffff;
  max-width: 345px;
  padding-bottom: 85px;
  border-radius: 16px;
  border: 1px solid #bad0fb;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 24px;
  font-size: 14px;
  color: #666666;
  background-image: url('../../../assets/images/detailsCard-large.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  .logo-box {
    width: 127px;
    height: 112px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .visit-name {
    height: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #1e2329;
    line-height: 24px;
    text-align: center;
    font-style: normal;
    margin: 8px 0 16px;
  }

  .visit-purpose {
    display: flex;
    align-items: center;
    height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 28px;
    color: #1e2329;
    line-height: 32px;
    text-align: center;
    font-style: normal;
  }

  .visit-text {
    max-width: 140px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .line {
    width: 263px;
    height: 1px;
    opacity: 0.19;
    border: 1px solid #a2a2a2;
    margin: 9px 0 15px;
  }

  .booking-type1 {
    display: flex;
    align-items: center;
    width: 250px;
    margin-bottom: 12px;

    .booking-child {
      padding-left: 12px;
    }
  }

  .cancel-invitation {
    margin-top: 40px;
    margin-bottom: 18px;
    height: 161px;
    width: 120px;
    text-align: center;

    img {
      height: 100px;
      width: 100px;
    }

    .cancel-font {
      margin-top: 4px;
      font-size: 14px;
      color: #666666;
      line-height: 24px;
    }
  }

  .code-box {
    display: flex;
    flex-direction: column;
    align-items: center;

    .code {
      width: 142px;
      height: 142px;
    }

    .verification {
      height: 42px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 36px;
      color: #1e2329;
      line-height: 42px;
      text-align: center;
      font-style: normal;
    }

    .button {
      width: 305px;
      height: 56px;
      background: #167aff;
      border-radius: 28px;
      margin-top: 86px;
      height: 56px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #ffffff;
      line-height: 56px;
      text-align: center;
      font-style: normal;
    }
  }
}

.booking-content {
  max-width: 345px;
  height: 682px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url('../../../assets/images/detailsCard-not.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  .img {
    margin-top: 109px;
    width: 272px;
    height: 204px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.approvalImg {
  width: 170px;
  height: 160px;
  margin-top: 40px;

  img {
    width: 100%;
    height: auto;
  }
}
</style>
